import { render } from "./indexpage.vue?vue&type=template&id=f53e8cf4"
import script from "./indexpage.vue?vue&type=script&lang=js"
export * from "./indexpage.vue?vue&type=script&lang=js"

import "./dashboard.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__